import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
var EdModalSearchBar = function (props) {
    var navigate = useNavigate();
    var ref = React.useRef(null);
    var handleClose = function () { return props.setShow(false); };
    React.useEffect(function () {
        if (props.show)
            document.body.classList.add("overflow-hidden");
        else
            document.body.classList.remove("overflow-hidden");
        return function () {
            document.body.classList.remove("overflow-hidden");
        };
    }, [props.show]);
    React.useEffect(function () {
        if (!props.DisableOutsideClickClose) {
            var handleClickOutside_1 = function (event) {
                if (ref.current &&
                    !ref.current.contains(event.target) &&
                    event.view.innerWidth - 17 >= event.clientX) {
                    props.setShow(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside_1);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside_1);
            };
        }
    }, [ref]);
    return (React.createElement(Modal, { show: props.show, onHide: handleClose, className: "generic-searchbar-modal-block ".concat(props.customClass ? props.customClass : "") },
        React.createElement(Modal.Header, null, props.headContent),
        React.createElement(Modal.Body, { className: "commonscroll-new" }, props.modalBodyContent),
        props.showFooter && React.createElement(Modal.Footer, null, props.footerContent)));
};
export default EdModalSearchBar;
